import React from 'react';

function FormInput({ title, errorText, inputOptions }) {
    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between">
                <label className='font-medium text-[14px] leading-6 text-[#121212] cursor-pointer' htmlFor="description">{title}</label>

                <p className='text-[12px] leading-5 text-[#EF4444]'>{errorText}</p>
            </div>

            <textarea 
                className='outline-none h-24 border border-[#EAEAEA] bg-[#F5F5F5] p-3 rounded-[9px] font-normal text-[12px] leading-6 text-[#121212] placeholder:text-[#666666]' 
                { ...inputOptions } 
            />
        </div>
    )
}

export default FormInput;
